<template>
  <div class="respiration">
    <v-speed-dial
      v-model="fab"
      top
      right
      direction="bottom"
      :open-on-hover="hover"
      :transition="transition"
      class="mr-5"
    >
      <template v-slot:activator>
        <v-btn v-model="fab" color="cyan darken-1" dark >
          <template v-if="fab">
            <v-icon>
              mdi-menu-up
            </v-icon>
          </template>
          <template v-else>
            <v-icon>
              mdi-menu-down
            </v-icon>
          </template>
            {{ $t("experiment.fab.reference") }}
        </v-btn>
      </template>
      <template>
        <v-btn dark color="indigo" @click="openLabManualDialog();getLabManual()">
          <v-icon>mdi-file-document</v-icon>
          {{ $t("experiment.fab.lab_manual") }}
        </v-btn>
      </template>
      <template>
        <v-btn  dark color="green"  @click="openSetupDialog(); getSetupPhoto()">
          <v-icon> mdi-image-search </v-icon>
          {{ $t("experiment.fab.setup_photo") }}
        </v-btn>
      </template>
      <template>
        <v-btn dark color="amber darken-3" @click="openVideoDemoDialog();getExperimentVideoDemo()">
          <v-icon>mdi-play-circle</v-icon>
          {{ $t("experiment.fab.video_demo") }}
        </v-btn>
      </template>
    </v-speed-dial>
    <v-row>
      <v-col xs="12" sm="4">
        <v-expansion-panels v-model="controlPanel" multiple>
          <v-expansion-panel>
            <v-expansion-panel-header color="green lighten-5">
              <h5>{{ $t("experiment.panel.real_time_header") }}</h5>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="control-content">
              <v-card>
                <v-card-text>
                  <v-row class="ml-1 mr-1">
                    <v-col xs="12" sm="12">
                      <h5><small>{{ $t("experiment.panel.control.respiration.co2.label") }}</small></h5>
                      <h4>{{ co2 }} <small>{{ $t("experiment.panel.control.respiration.co2.unit") }}</small></h4>
                    </v-col>
                  </v-row>
                  <v-overlay absolute :value="no_response">
                  <v-btn color="error">
                    {{ $t("experiment.panel.control.respiration.no_response_text") }}
                  </v-btn>
                </v-overlay>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header color="green lighten-5">
              <h5>{{ $t("experiment.panel.control_header") }}</h5>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="control-content">
              <v-card class="p-3">
                <v-overlay absolute :value="loop_flag || loading">
                  <v-btn color="primary">
                    {{ $t("experiment.panel.operating_prompt") }}
                    <v-progress-circular
                      indeterminate
                      size="12"
                      class="ma-4"
                    ></v-progress-circular>
                  </v-btn>
                </v-overlay>  
                <div v-if="current.user_level == 'INCHARGE' || current.user_level == 'ADMIN'">
                  <v-row class="mt-3" no-gutters>
                    <v-col>
                      <v-btn v-if="!capture" class="mx-4 success" @click="clientSetCommand('device_1', 'CAPTURE|1')">
                        {{ $t("experiment.panel.control.respiration.start_capture_btn") }}
                      </v-btn>
                      <v-btn v-if="capture" class="mx-4 warning" @click="clientSetCommand('device_1', 'CAPTURE|0')">
                        {{ $t("experiment.panel.control.respiration.stop_capture_btn") }}
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-divider></v-divider>
                </div>
                <v-row class="mt-3" no-gutters>
                  <v-col cols="12" class="px-3">
                      <v-checkbox
                        v-model="manual_yaxis"
                        :label="graphControlLabel('manual_y_axis')"
                        hide-details
                        @change="changeYAxis()"
                      >
                      </v-checkbox>
                      <v-expand-transition>
                        <div v-show="manual_yaxis">
                          <v-row class="ml-1 mr-1">
                            <v-col cols="12" class="pb-0">
                              <v-row>
                                <v-text-field
                                  hide-details
                                  type="number"
                                  :disabled="selected_graph[0]==undefined"
                                  v-model="data_1.max_input"
                                  :label="data_1.label_max"
                                  class="mx-4"
                                >
                                </v-text-field>
                              </v-row>
                              <v-row>
                                  <v-text-field
                                    type="number"
                                    :disabled="selected_graph[0]==undefined"
                                    v-model="data_1.min_input"
                                    :label="data_1.label_min"
                                    class="mx-4"
                                  >
                                  </v-text-field>
                                </v-row>
                            </v-col>
                          </v-row>
                          <v-btn class='btn mx-1 my-1' color='grey lighten-1' dark @click="resetYAxis()">{{ $t("experiment.panel.control.respiration.reset_y_axis") }}</v-btn>
                          <v-btn class='btn mx-1 my-1' color='green lighten-1' dark @click="changeYAxis()">{{ $t("experiment.panel.control.respiration.apply_y_axis") }}</v-btn>
                        </div>
                      </v-expand-transition>
                  </v-col>
                  <v-col cols="12">
                    <v-divider></v-divider>
                    <v-btn class="mx-4 my-2" @click="downloadZipGroupExperimentData('device_1')" color="primary">
                      {{ $t("experiment.panel.control.respiration.export_btn") }}
                    </v-btn>
                    <v-btn v-if="current.user_level == 'INCHARGE' || current.user_level == 'ADMIN'" class="mx-4 my-2" @click="clearCapture" color="error">
                      {{ $t("experiment.panel.control.respiration.clear_graph_btn") }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
      <v-col xs="12" sm="8">
        <v-expansion-panels v-model="controlPanel2" multiple>
          <v-expansion-panel>
            <v-expansion-panel-header color="green lighten-5">
              <h5>{{ $t("experiment.panel.measure_header") }}</h5>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <apexchart
                type="line"
                :options="options"
                :series="series"
                ref="realtimeChart"
              >
              </apexchart>
              
              <v-overlay absolute :value="loop_flag || loading">
                <v-btn color="primary">
                  {{ $t("experiment.panel.operating_prompt") }}
                  <v-progress-circular
                    indeterminate
                    size="12"
                    class="ma-4"
                  ></v-progress-circular>
                </v-btn>
              </v-overlay>
            </v-expansion-panel-content>            
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog_lab_manual" max-width="700px" >
      <v-card class="pb-3">
        <v-toolbar dark color="green">
          <v-btn icon dark @click="closeLabManualDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t("experiment.fab.dialog.lab_manual.header") }}</v-toolbar-title>
        </v-toolbar>
        <v-row justify="center" no-gutters>
          <v-col cols="11"  class="my-2 px-1">
            <v-row>              
              <v-col cols="12">
                <div v-if="lab_manual.school_chi.path!=null || lab_manual.school_en.path!=null">
                  <v-card class="p-1">
                    <v-card-text class="p-1">
                      <v-row>
                        <v-col class="" cols="12">
                          <div v-if="lab_manual.school_en.path!=null">
                            <v-icon class="p-1" color="primary">mdi-file-document-outline</v-icon><a :href="lab_manual.school_en.path" target="_BLANK">{{ lab_manual.school_en.filename }} {{ $t("experiment.fab.dialog.lab_manual.en_label") }}</a>
                          </div>
                          <div v-if="lab_manual.school_chi.path!=null">
                            <v-icon  class="p-1" color="primary">mdi-file-document-outline</v-icon><a :href="lab_manual.school_chi.path" target="_BLANK">{{ lab_manual.school_chi.filename }} {{ $t("experiment.fab.dialog.lab_manual.chi_label") }}</a>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </div>
                <div v-else-if="lab_manual.school_chi.path==null && lab_manual.school_en.path==null">
                  <v-card class="p-1">
                    <v-card-text class="p-1">
                      <v-row>
                        <v-col class="" cols="12">
                          <div v-if="lab_manual.suggested_en.path!=null">
                            <v-icon class="p-1" color="primary">mdi-file-document-outline</v-icon><a :href="lab_manual.suggested_en.path" target="_BLANK">{{ lab_manual.suggested_en.filename }} {{ $t("experiment.fab.dialog.lab_manual.en_label") }}</a>
                          </div>
                          <div v-if="lab_manual.suggested_chi.path!=null">
                            <v-icon  class="p-1" color="primary">mdi-file-document-outline</v-icon><a :href="lab_manual.suggested_chi.path" target="_BLANK">{{ lab_manual.suggested_chi.filename }} {{ $t("experiment.fab.dialog.lab_manual.chi_label") }}</a>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_setup" max-width="800px">
      <v-card>
        <v-toolbar dark color="green">
          <v-btn icon dark @click="closeSetupDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t("experiment.fab.dialog.setup_photo.header") }}</v-toolbar-title>
          <!--v-spacer></v-spacer-->
        </v-toolbar>
        <v-carousel v-model="model" height="auto">
          <v-carousel-item
            v-for="(item,i) in setup_photos"
            :key="i"
            :src="item.src"
          >
          </v-carousel-item>
        </v-carousel>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_video_demo" max-width="700px" >
      <v-card class="pb-3">
        <v-toolbar dark color="green">
          <v-btn icon dark @click="closeVideoDemoDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t("experiment.fab.dialog.video_demo.header") }}</v-toolbar-title>
        </v-toolbar>
        <v-row justify="center" no-gutters>
          <v-col cols="11"  class="my-2 px-1">
            <v-row>              
              <v-col cols="12">
                <div v-if="video_demo.school_chi.path!=null || video_demo.school_en.path!=null">
                  <v-card class="p-1">
                    <v-card-text class="p-1">
                      <v-row>
                        <v-col class="" cols="12">
                          <div v-if="video_demo.school_en.path!=null">
                            <v-icon class="p-1" color="primary">mdi-play-circle</v-icon><a :href="video_demo.school_en.path" target="_BLANK">{{ video_demo.school_en.filename }} {{ $t("experiment.fab.dialog.video_demo.en_label") }}</a>
                          </div>
                          <div v-if="video_demo.school_chi.path!=null">
                            <v-icon  class="p-1" color="primary">mdi-play-circle</v-icon><a :href="video_demo.school_chi.path" target="_BLANK">{{ video_demo.school_chi.filename }} {{ $t("experiment.fab.dialog.video_demo.chi_label") }}</a>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </div>
                <div v-else-if="video_demo.school_chi.path==null && video_demo.school_en.path==null">
                  <v-card class="p-1">
                    <v-card-text class="p-1">
                      <v-row>
                        <v-col class="" cols="12">
                          <div v-if="video_demo.suggested_en.path!=null">
                            <v-icon class="p-1" color="primary">mdi-play-circle</v-icon><a :href="video_demo.suggested_en.path" target="_BLANK">{{ video_demo.suggested_en.filename }} {{ $t("experiment.fab.dialog.video_demo.en_label") }}</a>
                          </div>
                          <div v-if="video_demo.suggested_chi.path!=null">
                            <v-icon  class="p-1" color="primary">mdi-play-circle</v-icon><a :href="video_demo.suggested_chi.path" target="_BLANK">{{ video_demo.suggested_chi.filename }} {{ $t("experiment.fab.dialog.video_demo.chi_label") }}</a>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ExperimentTitle from "@/components/ExperimentTitle.vue";
import ExperimentBasic from "@/services/iot/api_basic_experiment";
export default {
  name: "respiration",
  components: {
    ExperimentTitle,
  },
  mixins: [ExperimentBasic],
  data: function () {
    return {
      controlAuth: true,
      model: 0,
      dialog_setup: false,
      dialog_lab_manual: false,
      dialog_video_demo: false,
      checkEnd: true,
      direction: 'bottom',
      fab: false,
      fling: false,
      hover: false,
      tabs: null,
      top: true,
      right: true,
      bottom: false,
      left: false,
      transition: 'slide-y-reverse-transition',
      current: {
        username: null,
        user_level: "USER",
        school_id: null,
        auth_token: null,
        experiment: null,
        equipment_id: null,
        booking_id: null,
      },
      controlPanel: [0, 1],
      controlPanel2: [0],
      realTimePanel: 0,
      stored_data: [["Time", "CO2"]],
      is_capturing: false,
      capture: 0,
      timer: 0,
      time_now: null,
      counter: 0,
      realtime_interval: null,
      loop_interval: 10000,
      mounted_interval_1: null,
      no_response: 1,
      selected_graph: ["CO2"],
      graph_units: {"CO2":"ppm"},
      graph_names: {"CO2":"CO₂"},
      graph_chi_names: {"CO2":"二氧化碳"},
      graphs: [
        {"value": "CO2", "text": "CO₂", "text_chi": "二氧化碳"}
      ],
      data_1: {
        manual_max: undefined,
        manual_min: undefined,
        data_max: undefined,
        data_min: undefined,
        max_input: undefined,
        min_input: undefined,
        label_max: "Max: CO₂",
        label_min: "Min: CO₂"
      },
      data_2: {
        manual_max: undefined,
        manual_min: undefined,
        data_max: undefined,
        data_min: undefined,
        max_input: undefined,
        min_input: undefined,
        label_max: "",
        label_min: ""
      },
      yaxis_apply: true,
      manual_yaxis: false,
      battery: 100,
      voltage: 0,
      current_ma: 0,
      power: 0,
      co2: 0,
      step_status: "",
      loading: false,
      loop_flag: false,
      setup_photos: [],
      lab_manual:{
        school_chi: { path: null, filename: null },
        school_en: { path: null, filename: null },
        suggested_chi: { path: null, filename: null },
        suggested_en: { path: null, filename: null },
      },
      video_demo:{
        school_chi: { path: null, filename: null },
        school_en: { path: null, filename: null },
        suggested_chi: { path: null, filename: null },
        suggested_en: { path: null, filename: null },
      },
      api: {
        value: "",
        value_got_at: null,
        value_set_at: null,
      },      
      options: {
        colors: ["#FF0000", "#0000FF"],
        width: "100%",
        stroke: {
          width: 1,
        },

        yaxis: {
          title: {
            text: "",
          },
        },
        xaxis: {
          tickAmount: 10,
          labels: {
            show: true,
            hideOverlappingLabels: true,
          },
          title: {
            text: "Time (minutes)",
            offsetY: 10,
          },
          labels: {
            formatter: function(val) {
              return parseFloat(val).toFixed(2);
            }
          }
        },
      },      
      options_chi: {
        width: "100%",
        stroke: {
          width: 1,
        },yaxis: {
          title: {
            text: "",
          },
        },
        xaxis: {
          tickAmount: 10,
          labels: {
            show: true,
            hideOverlappingLabels: true,
          },
          title: {
            text: "時間(分鐘)",
            offsetY: 10,
          },
          labels: {
            formatter: function(val) {
              return parseFloat(val).toFixed(2);
            }
          }
        },
      },
      series: [
        {
          name: "Set 1",
          data: [],
        },
        {
          name: "Set 2",
          data: [],
        },
      ],
      
      series_chi: [
        {
          name: "圖表一",
          data: [],
        },
        {
          name: "圖表二",
          data: [],
        },
      ],
    };
  },
  mounted: function () {    
    var self = this;
    self.checkEnd = self.$parent.checkEnd;
    self.current.school_id = self.$store.state.user.school_id;
    self.current.username = self.$store.state.user.username;
    self.current.user_level = self.$store.state.user.user_level;
    self.current.auth_token = self.$store.state.user.auth_token;
    self.school_id = self.$route.params.school_id;
    self.experiment = self.$route.query.experiment;
    self.equipment_id = self.$route.query.equipment;
    self.getGroupValue("device_1", "group_experiment", function () {
      self.battery = self.api.value.Battery,
      self.voltage = self.api.value.Voltage,
      self.current_ma = self.api.value.Current,
      self.power = self.api.value.Power,
      self.co2 = self.api.value.CO2,
      self.capture = self.api.value.capture;      
      self.time_now = Date.now()/1000;
      if(self.time_now-self.api.value_set_at > 10) {
        self.no_response = true;
        self.clearRealtimeInterval()
      }
      else {
        self.no_response = false;
        self.startRealtimeInterval();
      }
    });
    
    self.getChartMultiple("device_1", 1, "CO2", null);
    self.checkGroupSlotOverrided();

    self.mounted_interval_1 = setInterval(function () {
      self.getGroupValue("device_1", "group_experiment", function () {
        self.time_now = Date.now()/1000;
        if(self.time_now-self.api.value_set_at > 10) {
          self.no_response = true;
          self.clearRealtimeInterval();
        }
        else {
          self.no_response = false;
          self.clearRealtimeInterval();
          self.startRealtimeInterval();
          self.getChartMultiple("device_1", 1, "CO2", null);
        }
      });
    }, 150000);
    self.experiment_name = "PHOTOTHESYNSIS";
    
    setInterval(function () {
      //loop distance value
      if (self.loop_flag) {
        self.getGroupValue("device_1", "group_experiment", function () {
          if (self.api.value_set_at >= self.api.command_set_at) {
            self.loop_flag = false;
            self.capture = self.api.value.capture;            
            self.co2 = self.api.value.CO2;
          }
        });
      }
    }, 1000);
  },
  methods: {
    graphControlLabel(label) {
      var self = this;
      if(label=='select_graph') {
        return self.$t("experiment.panel.control.respiration.select_graph");
      }
      else if(label=='manual_y_axis'){
        return self.$t("experiment.panel.control.respiration.manual_y_axis");
      }
    },
    openLabManualDialog(){
      var self = this;
      self.dialog_lab_manual = true;
    },
    closeLabManualDialog(){
      var self = this;
      self.dialog_lab_manual = false;
    },
    openSetupDialog(){
      var self = this;
      self.dialog_setup = true;
    },
    closeSetupDialog(){
      var self = this;
      self.dialog_setup = false;
    },
    openVideoDemoDialog(){
      var self = this;
      self.dialog_video_demo = true;
    },
    closeVideoDemoDialog(){
      var self = this;
      self.dialog_video_demo = false;
    },
    changeCheck(){
      var self = this;
      self.$emit("changeCheck");
      self.checkEnd = self.$parent.checkEnd;
    },
    changeYAxis(){
      var self = this;
      if(self.manual_yaxis == false){
        self.data_1.manual_max = undefined;
        self.data_1.manual_min = undefined;
        self.data_2.manual_max = undefined;
        self.data_2.manual_min = undefined;
        self.applyManualYAxis("multiple", 1);
      }
      else {
        if( (!(isNaN(self.data_1.max_input) || isNaN(self.data_1.min_input))) || ( !( isNaN(self.data_2.max_input) || isNaN(self.data_2.min_input) ) ) )
          self.applyManualYAxis("multiple", 1);
      }
    },    
    resetYAxis: function () {
      var self = this;
      var r = confirm("You are setting the y axis to auto-scale. Continue?");
      if (r == true) {
        self.data_1.manual_max = undefined;
        self.data_1.manual_min = undefined;
        self.data_2.manual_max = undefined;
        self.data_2.manual_min = undefined;

        self.data_1.max_input = undefined;
        self.data_1.min_input = undefined;
        self.data_2.max_input = undefined;
        self.data_2.min_input = undefined;

        self.applyManualYAxis("multiple", 1);
      }
    },
    clearCapture: function () {
      var self = this;
      if(self.capture==1){
        alert("Please stop capture before clearing graph.");
      }
      else {
        var r = confirm("Are you sure to clear the graph?");
        if (r == true) {
          self.clearChartMultiple("device_1", 1, ['CO2']);
        }
      }
    },
    startRealtimeInterval(){
      var self = this;
      self.realtime_interval = setInterval(function () {
        self.getGroupValue("device_1", "group_experiment", function () {
          self.co2 = self.api.value.CO2,
          self.capture = self.api.value.capture;
        });
      }, 2000);
    },
    clearRealtimeInterval(){
      var self = this;
      clearInterval(self.realtime_interval);
    },
  },
  watch: {
    '$i18n.locale'(newLocale) {
      var self = this;
      if (newLocale === 'tc') {
        self.$refs.realtimeChart.updateSeries(self.series_chi);
        self.$refs.realtimeChart.updateOptions(self.options_chi);
        if(self.selected_graph.length >= 1) {
          self.data_1.label_max = "最大：" + self.graph_chi_names[self.selected_graph[0]];
          self.data_1.label_min = "最小：" + self.graph_chi_names[self.selected_graph[0]];
        }
        else {
          self.data_1.label_max = "";
          self.data_1.label_min = "";
          self.data_2.label_max = "";
          self.data_2.label_min = "";
        }
      }
      else {
        self.$refs.realtimeChart.updateSeries(self.series);
        self.$refs.realtimeChart.updateOptions(self.options);
        if(self.selected_graph.length >= 1) {
          self.data_1.label_max = "Max: " + self.graph_names[self.selected_graph[0]];
          self.data_1.label_min = "Min: " + self.graph_names[self.selected_graph[0]];
        }
        else {
          self.data_1.label_max = "";
          self.data_1.label_min = "";
          self.data_2.label_max = "";
          self.data_2.label_min = "";
        }
      }
    }
  },
  destroyed() {
    clearInterval(this.mounted_interval_1);
    this.clearRealtimeInterval();
  }
};
</script>
<style>
  /* This is for documentation purposes and will not be needed in your application */
  .v-speed-dial {
    position: absolute;
    z-index: 2;
  }

  .v-btn--floating {
    position: relative;
    z-index: 5;
  }
  
  .control-content>.v-expansion-panel-content__wrap{
    padding: 0;
  }
</style>
